import React from "react";
import { Dialog, Icon, Button } from "@app/components";
import { ChangeConfirmationContentWrapper, ChangeDialogConfirmationText, DialogFooter } from "@app/components/dialog/dialog-components";

export default function ChangeAccountDialog({ onClose, onChangeLicense }: any) {
  return (
    <Dialog onClose={onClose} noTitle={true}>
      <ChangeConfirmationContentWrapper>
        <Icon name="warn" />
        <ChangeDialogConfirmationText className="text-center">
          All the changes made will be lost. Are you sure you want to change the Account type?
        </ChangeDialogConfirmationText>
        <DialogFooter className="h-unset with-no-border">
          <Button variant="text" onClick={onClose}>Cancel</Button>
          <Button variant="newsecondary" onClick={onChangeLicense}>Ok</Button>
        </DialogFooter>
      </ChangeConfirmationContentWrapper>
    </Dialog>
  );
}
